import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const newUser = createAsyncThunk(
  "register/fetch",
  async (allData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/registerUser`, allData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const registerSlice = createSlice({
  name: "register",
  initialState: {
    data: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(newUser.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(newUser.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(newUser.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});

export default registerSlice.reducer;

// import axiosInstance from "../../../services/axiosInstance";
// import { STATUSES } from "./apiStatus";
// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// const registerSlice = createSlice({
//   name: "register",
//   initialState: {
//     data: "",
//     status: STATUSES.IDLE,
//   },

//   extraReducers: (builder) => {
//     builder
//       .addCase(register.pending, (state, action) => {
//         state.status = STATUSES.LOADING;
//       })
//       .addCase(register.fulfilled, (state, action) => {
//         state.data = action.payload;
//         state.status = STATUSES.IDLE;
//       })
//       .addCase(register.rejected, (state, action) => {
//         state.status = STATUSES.ERROR;
//       });
//   },
// });

// export default registerSlice.reducer;

// //Thunk ===>
// //fetch with post methode?
// export const register = createAsyncThunk("register/fetch", async (allData) => {
//   const data = await axios.post("EsignServices/registerUser" , allData).then((response)=>{
//     return response
//   })
//   return data;
// });
